import { createFileRoute } from '@tanstack/react-router';

import { QuotationsPage } from '@/areas/quotations/Quotations/QuotationsPage';
import { canViewQuotation } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/quotation')({
    staticData: { access: { permissions: canViewQuotation }, chrome: 'project' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <QuotationsPage {...pathParams} />;
}
